export default __webpack_public_path__ + "static/media/leftArrow.0438d46f.svg";